import {combineReducers} from 'redux';
import userReducer from './User/user_reducer';
import tripRecuder from './Trip/trip_reducer';


const rootReducer = combineReducers({
    user: userReducer,
    trip: tripRecuder
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js